import { EffectReducer } from 'use-effect-reducer'
import { PMOFEffect, PMOFEvent, PMOFState } from './types'

export const pmofStateReducer: EffectReducer<
  PMOFState,
  PMOFEvent,
  PMOFEffect
> = (state, event, exec) => {
  switch (event.type) {
    case 'PROCESS_PAYMENT': {
      exec({ type: 'processPaymentEffect' })
      return { status: 'processing' }
    }
    case 'RETRY': {
      exec({ type: 'processPaymentEffect' })
      return { status: 'processing' }
    }
    case 'DONE': {
      return { status: 'done', transaction: event.transaction }
    }
    case 'ERROR': {
      return { status: 'error', errorMessage: event.errorMessage }
    }
    default: {
      const _exhaustive: never = event
      return _exhaustive
    }
  }
}
